import axios, { AxiosInstance } from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8100'

const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Intercepteur pour ajouter le token JWT à chaque requête
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('claudie_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Intercepteur pour gérer les erreurs 401 (token expiré)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url: string = error.config?.url || ''
    // Les routes de login/2FA gèrent leurs propres 401 (mauvais mdp / mauvais code)
    // et doivent afficher l'erreur inline, PAS recharger la page.
    const isAuthFlow = url.includes('/auth/login') || url.includes('/auth/verify-otp')
    if (error.response?.status === 401 && !isAuthFlow) {
      // Token expiré ou invalide sur une requête authentifiée
      localStorage.removeItem('claudie_token')
      localStorage.removeItem('claudie_user')
      window.location.reload() // Recharge pour afficher la page de login
    }
    return Promise.reject(error)
  }
)

export default api
